// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingContactApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AdManagementBillingContactOverviewDto, AdManagementBillingContactSaveDto } from '../..';

interface GetBillingContactV2Params {
  accountNumber: string;
}

export const AdproductsUserBillingContactApiHandler_getBillingContactV2_Path =
  '/api/web/v1/users/billing/contacts/getBillingContactV2';

/**
 * Get billing contact V2 details for logged-in user and account
 */
export const AdproductsUserBillingContactApiHandler_getBillingContactV2 = (
  getParams: GetBillingContactV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetBillingContactV2Params, never, AdManagementBillingContactOverviewDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingContactApiHandler_getBillingContactV2_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingContactApiHandler_saveBillingContactV2_Path =
  '/api/web/v1/users/billing/contacts/saveBillingContactV2';

/**
 * Save billing contact V2 details for logged-in user and account
 */
export const AdproductsUserBillingContactApiHandler_saveBillingContactV2 = (
  postData: AdManagementBillingContactSaveDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AdManagementBillingContactSaveDto, void>(
    {
      endpoint: AdproductsUserBillingContactApiHandler_saveBillingContactV2_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
